export default __webpack_public_path__ + "static/media/PharmacyCard.79e60552.svg";